import React, { useState } from "react";
import { Row, Col, message, Form, Input, Button, Upload, Spin } from "antd";
import firebase from "../../config/FirebaseConfig";
import { useHistory } from "react-router-dom";
import crypto from "crypto-js";
import "./Register.css";

export default function Register() {
  const [sipFileList, setSIPFileList] = useState([]);
  const [ijazahFileList, setIjazahFileList] = useState([]);
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const onChangeSIP = ({ file, onSuccess }) => {
    setTimeout(() => {
      setSIPFileList([file]);
      onSuccess("ok");
    }, 0);
  };
  const onChangeIjazah = ({ file, onSuccess }) => {
    setTimeout(() => {
      setIjazahFileList([file]);
      onSuccess("ok");
    }, 0);
  };

  const formLayout = {
    labelCol: { span: 24 },
    wrapperCol: { span: 24 },
  };

  const handleSubmit = (values) => {
    let sipDownloadURL;
    let ijazahDownloadURL;
    setLoading(true);
    Promise.all([
      firebase
        .storage()
        .ref(`psikolog/${values.name}/${sipFileList[0].name}`)
        .put(sipFileList[0])
        .then(async (snapshot) => {
          sipDownloadURL = await snapshot.ref.getDownloadURL();
          console.log("Uploaded successfully");
        })
        .catch((err) => {
          console.log(err);
        }),
      firebase
        .storage()
        .ref(`psikolog/${values.name}/${ijazahFileList[0].name}`)
        .put(ijazahFileList[0])
        .then(async (snapshot) => {
          ijazahDownloadURL = await snapshot.ref.getDownloadURL();
          console.log("Uploaded successfully");
        })
        .catch((err) => {
          console.log(err);
        }),
    ])
      .then(() => {
        firebase
          .firestore()
          .collection("temp")
          .add({
            IDCardNumber: values.idCardNumber,
            address: values.address,
            email: values.email,
            name: values.name,
            phoneNumber: values.phoneNumber,
            experience: values.duration,
            password: crypto.AES.encrypt(
              values.password,
              "!@#Carenting"
            ).toString(),
            certificate: ijazahDownloadURL,
            sip: sipDownloadURL,
            imgPath:
              "https://firebasestorage.googleapis.com/v0/b/carenting-8c923.appspot.com/o/default%2Fdoctor.png?alt=media&token=64982989-1716-46b1-8549-8d3e5b99bb88",
            summary: "",
            status: "inactive",
            timestamp: firebase.firestore.Timestamp.now(),
          })
          .then(() => {
            setLoading(false);
            message.success(
              "Registrasi berhasil, silahkan tunggu email verifikasi"
            );
            setTimeout(() => {
              history.push("/");
            }, 1000);
          })
          .catch((err) => {
            setLoading(false);
            message.error("Registrasi gagal");
            console.log(err);
          });
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
        message.error("Registrasi gagal");
      });
  };

  return (
    <section
      id="register"
      style={{
        backgroundColor: "#FAFAFA",
        minHeight: "100vh",
        padding: "0 5vh",
      }}
    >
      <Row
        style={{
          paddingLeft: "5vh",
          paddingTop: "3vh",
        }}
      >
        <Col>
          <img
            alt="logo"
            src={process.env.PUBLIC_URL + "/asset/logo_blue.png"}
            style={{
              width: "240px",
              height: "auto",
            }}
          />
        </Col>
      </Row>
      <div className="info">
        <div className="header">Register to be Psychologist</div>
        <div className="detail">
          Hi, let’s join us to be the psychologist in Carenting by register here
        </div>
      </div>
      <Form
        {...formLayout}
        name="register"
        className="form"
        onFinish={handleSubmit}
      >
        <Row justify="space-around" align="middle">
          <Col span={10}>
            <Form.Item
              label="Nama"
              name="name"
              rules={[{ required: true, message: "Mohon isi nama anda!" }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="No. Identitas"
              name="idCardNumber"
              rules={[
                {
                  required: true,
                  message: "Mohon isi Nomor Identitas KTP anda!",
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="No. HP"
              name="phoneNumber"
              rules={[{ required: true, message: "Mohon isi No HP anda!" }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="Alamat"
              name="address"
              rules={[{ required: true, message: "Mohon isi nama anda!" }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="Tahun Pertama Praktek"
              name="duration"
              rules={[
                {
                  required: true,
                  message: "Mohon isi tahun pertama praktek anda!",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={10}>
            <Form.Item
              label="Email"
              name="email"
              rules={[{ required: true, message: "Mohon isi email anda!" }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="Password"
              name="password"
              rules={[
                {
                  required: true,
                  message: "Mohon isi password anda!",
                },
              ]}
            >
              <Input.Password />
            </Form.Item>
            <Form.Item
              label="Konfirmasi Password"
              name="confirmPass"
              dependencies={["password"]}
              rules={[
                {
                  required: true,
                  message: "Mohon isi konfirmasi password anda!",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject("Password tidak sesuai!");
                  },
                }),
              ]}
            >
              <Input.Password />
            </Form.Item>
            <Form.Item label="Surat Izin Praktek (Masih Aktif)">
              <Upload
                customRequest={onChangeSIP}
                fileList={sipFileList}
                onRemove={() => {
                  setSIPFileList([]);
                }}
                name="sip"
              >
                <Button className="button_primary">Upload</Button>
              </Upload>
            </Form.Item>
            <Form.Item label="Ijazah Terakhir">
              <Upload
                customRequest={onChangeIjazah}
                fileList={ijazahFileList}
                onRemove={() => {
                  setIjazahFileList([]);
                }}
                name="ijazah"
              >
                <Button className="button_primary">Upload</Button>
              </Upload>
            </Form.Item>
          </Col>
        </Row>
        <Row justify="end">
          <Button className="button_secondary" htmlType="submit">
            {loading ? <Spin /> : "Register"}
          </Button>
        </Row>
      </Form>
    </section>
  );
}
